import * as React from "react";
import { forwardRef } from "react";
const SvgChevronRight = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, viewBox: "0 0 32 32", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "m12.943 24.943 8-8a1.332 1.332 0 0 0 0-1.885l-8-8a1.332 1.332 0 1 0-1.885 1.885L18.115 16l-7.057 7.057a1.332 1.332 0 1 0 1.885 1.885v.001Z" }));
const ForwardRef = forwardRef(SvgChevronRight);
export default ForwardRef;
